import React from "react";
import { IoAlertCircle } from "react-icons/io5";

export const TableAlert = (props) => (
  <>
    {props.alert && (
      <span className="right error" id="table-alert">
        {" "}
        <IoAlertCircle className=" error" style={{ fontSize: "1.3em", marginBottom: "-3px" }} />
        {props.alert}
      </span>
    )}
  </>
);
